export default "__VITE_ASSET__D_eZ7bYc__"